import React, { useEffect, useState } from 'react'
import { CBadge, CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import CommonService from 'src/service/CommonService'
import MemberCodeListing from './MemberCodeListing'

const COLUMNS = [
  { label: 'Code', filter: true, sorter: true, key: 'invite_code' },
  { label: 'First Name', filter: true, sorter: true, key: 'first_name' },
  { label: 'Last Name', filter: true, sorter: true, key: 'last_name' },
  { label: 'Email', filter: true, sorter: true, key: 'email' },
  { label: 'Created On', filter: false, sorter: true, key: 'created_at' },
  { label: 'Sent', filter: false, sorter: true, key: 'is_sent' },
  { key: 'actions', label: 'Actions', filter: false, sorter: false },
]

// Shared "Invitations" list for the whole Invitation step. Rendered once beneath the tab
// content in GameEntrySettings (not once per tab) since it's the same underlying game-guest
// codes regardless of whether a guest was imported, added manually, or invited from a
// previous game. `reloadToken` lets those tabs ask this list to refetch after they add guests.
const GameGuestInvitations = ({ reloadToken }) => {
  const [loading, setLoading] = useState()
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState({})

  const fetchData = (
    pageParam = activePage,
    filterParam = columnFilter,
    sorterParam = columnSorter,
    perPageParam = itemsPerPage,
  ) => {
    const offset = perPageParam * pageParam - perPageParam
    const params = new URLSearchParams()
    Object.keys(filterParam || {}).forEach((key) => {
      params.append(key, filterParam[key])
    })
    sorterParam &&
      sorterParam.column !== undefined &&
      params.append('sort', `${sorterParam.column}%${sorterParam.state}`)

    CommonService.getJoinCodeMember(offset, perPageParam, pageParam, params).then((result) => {
      setUsers(result.data)
      setLoading(false)
    })
  }

  useEffect(() => {
    fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, columnFilter, columnSorter, itemsPerPage, reloadToken])

  return (
    <CCard className="border-secondary-subtle rounded-4">
      <CCardHeader className="bg-white d-flex align-items-center gap-2">
        <strong>Invitations</strong>
        <CBadge color="secondary" shape="rounded-pill">
          {users?.total ?? 0}
        </CBadge>
      </CCardHeader>
      <CCardBody>
        <MemberCodeListing
          users={users}
          columns={COLUMNS}
          itemsPerPage={itemsPerPage}
          loading={loading}
          activePage={activePage}
          columnFilter={columnFilter}
          columnSorter={columnSorter}
          setActivePage={setActivePage}
          setItemsPerPage={setItemsPerPage}
          setColumnSorter={setColumnSorter}
          setColumnFilter={setColumnFilter}
          fetchData={fetchData}
          setLoading={setLoading}
        />
      </CCardBody>
    </CCard>
  )
}

export default GameGuestInvitations
